var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-4"},[_c('h2',{staticClass:"my-2"},[_vm._v("Pessoas")]),_c('list',{attrs:{"url":"/people/search_person","title":"Pessoas","attribute":"people","listBy":"name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }